var _path, _line, _path2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVoucher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5H0.5C0.5 5.27614 0.723858 5.5 1 5.5V5ZM1 9V8.5C0.723858 8.5 0.5 8.72386 0.5 9H1ZM19 9H19.5C19.5 8.72386 19.2761 8.5 19 8.5V9ZM19 5V5.5C19.2761 5.5 19.5 5.27614 19.5 5H19ZM3.5 7C3.5 5.61929 2.38071 4.5 1 4.5V5.5C1.82843 5.5 2.5 6.17157 2.5 7H3.5ZM1 9.5C2.38071 9.5 3.5 8.38071 3.5 7H2.5C2.5 7.82843 1.82843 8.5 1 8.5V9.5ZM1.5 11L1.5 9H0.5L0.5 11H1.5ZM3 12.5C2.17157 12.5 1.5 11.8284 1.5 11H0.5C0.5 12.3807 1.61929 13.5 3 13.5V12.5ZM17 12.5H3V13.5H17V12.5ZM18.5 11C18.5 11.8284 17.8284 12.5 17 12.5V13.5C18.3807 13.5 19.5 12.3807 19.5 11H18.5ZM18.5 9V11H19.5V9H18.5ZM19 8.5C18.1716 8.5 17.5 7.82843 17.5 7H16.5C16.5 8.38071 17.6193 9.5 19 9.5V8.5ZM17.5 7C17.5 6.17157 18.1716 5.5 19 5.5V4.5C17.6193 4.5 16.5 5.61929 16.5 7H17.5ZM18.5 3V5H19.5V3H18.5ZM17 1.5C17.8284 1.5 18.5 2.17157 18.5 3H19.5C19.5 1.61929 18.3807 0.5 17 0.5V1.5ZM3 1.5H17V0.5H3L3 1.5ZM1.5 3C1.5 2.17157 2.17157 1.5 3 1.5L3 0.5C1.61929 0.5 0.5 1.61929 0.5 3H1.5ZM1.5 5V3H0.5L0.5 5H1.5Z",
    fill: "#6677FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 12.5,
    x2: 6.5,
    y2: 1.5,
    stroke: "#6677FF",
    strokeLinecap: "round",
    strokeDasharray: "4 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6465 9.35352L9.64648 4.35352",
    stroke: "#6677FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 5,
    r: 1,
    transform: "rotate(-90 14 5)",
    stroke: "#6677FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 1,
    transform: "rotate(-90 10 9)",
    stroke: "#6677FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVoucher);
export default __webpack_public_path__ + "static/media/ic_voucher.1afb37b78d41e9b378dbe79121fa0459.svg";
export { ForwardRef as ReactComponent };